import Globe from '@apps-common/react-globe';
import MapTool from '@apps-common/ui-maps/MapTool';
import MapToolbar from '@apps-common/ui-maps/MapToolbar.jsx';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import {Box, useTheme} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import {changeMapView} from '@explorer/actions/map';
import {trackEvent} from '@explorer/analytics';

const ZoomControls = props => {
  const theme = useTheme();
  const {t} = useTranslation();
  const onZoom = newZoom => {
    if (newZoom < props.minZoom || newZoom > props.maxZoom) {
      return;
    }
    props.changeMapView({zoom: newZoom});
  };

  const onZoomIn = () => {
    trackEvent('Zoom tool clicked', {
      name: 'Zoom in',
    });
    onZoom(Math.floor(props.zoom + 1));
  };

  const onZoomOut = () => {
    trackEvent('Zoom tool clicked', {
      name: 'Zoom out',
    });
    onZoom(Math.ceil(props.zoom - 1));
  };

  return (
    <MapToolbar>
      <MapTool
        icon={<AddIcon />}
        disabled={props.zoom >= props.maxZoom}
        tooltipTitle={t('mapTools.zoomIn')}
        onClick={onZoomIn}
        value="zoom-in"
      />
      <MapTool
        icon={<RemoveIcon />}
        disabled={props.zoom <= props.minZoom}
        tooltipTitle={t('mapTools.zoomOut')}
        onClick={onZoomOut}
        value="zoom-out"
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 38,
          height: 60,
          marginTop: -1,
        }}
      >
        <Globe
          center={props.center}
          landColor={theme.palette.common.white}
          markerColor={theme.palette.primary.main}
          oceanColor="#393a3f"
          diameter={55}
        />
      </Box>
      {props.additionalControls}
    </MapToolbar>
  );
};

ZoomControls.propTypes = {
  changeMapView: PropTypes.func,
  maxZoom: PropTypes.number,
  minZoom: PropTypes.number,
  zoom: PropTypes.number,
  center: PropTypes.array.isRequired,
  additionalControls: PropTypes.node,
};

const mapStateToProps = state => ({
  zoom: state.map.zoom,
  center: state.map.center,
});

const mapDispatchProps = {
  changeMapView,
};

export default connect(mapStateToProps, mapDispatchProps)(ZoomControls);
